<template>
    <v-container>
        <statistical-header :title="title"></statistical-header>
        <loader v-if="loading" />
        <template v-if="!loading">
            <v-layout row wrap align-left>
                <v-flex class="shrink handbook-leftDivider_hideSmall">
                    <v-btn-toggle v-model="toggleChambers"  @change="onToggle"  class="transparent handbook_toggleButton" :mandatory="true" :multiple="true">
                        <v-tooltip top :disabled="this.$vuetify.breakpoint.name !== 'md'">
                            <template v-slot:activator="{ on }">
                                <v-btn v-on="on" class="handbook_button" :value="'house'" :color="$store.state.COLOUR_REPRESENTATIVES"><span class="long-button-text chamberButton">House</span></v-btn>
                            </template>
                            <span>House</span>
                        </v-tooltip>
                        <v-tooltip top :disabled="this.$vuetify.breakpoint.name !== 'md'">
                            <template v-slot:activator="{ on }">
                                <v-btn v-on="on" class="handbook_button" :value="'senate'" :color="$store.state.COLOUR_SENATE_BRIGHT"><span class="long-button-text chamberButton">Senate</span></v-btn>
                            </template>
                            <span>Senate</span>
                        </v-tooltip>
                        <v-tooltip top :disabled="this.$vuetify.breakpoint.name !== 'md'">
                            <template v-slot:activator="{ on }">
                                <v-btn v-on="on" class="handbook_button" :value="'joint'" :color="$store.state.COLOUR_JOINT"><span class="long-button-text chamberButton">Joint</span></v-btn>
                            </template>
                            <span>Senate</span>
                        </v-tooltip>
                    </v-btn-toggle>
                </v-flex>
                <v-flex style="padding-left: 2rem" class="shrink handbook-leftDivider_hideSmall">
                    <v-btn-toggle v-model="toggleType"  @change="onToggle"  class="transparent handbook_toggleButton" :mandatory="true" :multiple="true">
                        <v-tooltip top :disabled="this.$vuetify.breakpoint.name !== 'md'">
                            <template v-slot:activator="{ on }">
                                <v-btn v-on="on" :value="'Standing'" ><span class="long-button-text">Standing</span></v-btn>
                            </template>
                            <span>Standing</span>
                        </v-tooltip>
                        <v-tooltip top :disabled="this.$vuetify.breakpoint.name !== 'md'">
                            <template v-slot:activator="{ on }">
                                <v-btn v-on="on" :value="'Select'" ><span class="long-button-text">Select</span></v-btn>
                            </template>
                            <span>Select</span>
                        </v-tooltip>
                         <v-tooltip top :disabled="this.$vuetify.breakpoint.name !== 'md'">
                            <template v-slot:activator="{ on }">
                                <v-btn v-on="on" :value="'Statutory'" ><span class="long-button-text">Statutory</span></v-btn>
                            </template>
                            <span>Statutory</span>
                        </v-tooltip>
                        <v-tooltip top :disabled="this.$vuetify.breakpoint.name !== 'md'">
                            <template v-slot:activator="{ on }">
                                <v-btn v-on="on" :value="'Estimates'" ><span class="long-button-text">Estimates</span></v-btn>
                            </template>
                            <span>Estimates</span>
                        </v-tooltip>
                        <v-tooltip top :disabled="this.$vuetify.breakpoint.name !== 'md'">
                            <template v-slot:activator="{ on }">
                                <v-btn v-on="on" :value="'Legislative and General Purpose Standing'" ><span class="long-button-text">Legislative and General Purpose Standing</span></v-btn>
                            </template>
                            <span>Legislative and General Purpose Standing</span>
                        </v-tooltip>
                    </v-btn-toggle>
                </v-flex>
            </v-layout>

            <br />

            <chart :chartData="timelineChartData" />

             <br />
            <v-data-table
                :headers="HEADERS"
                :items="DATATABLE_COMMITTEES"
                :rows-per-page-items="ROWS_LISTITEMS"
                :pagination.sync="PAGINATION"
                v-on:update:pagination="UPDATE_PAGINATION"
                class="elevation-1"
            >
                <template v-slot:items="props">
                    <td class="text-xs-left">
                    <v-chip :class="props.item.Type.indexOf('General Purpose') > -1 ? 'generalPurposeStanding' : ''"
                        small label
                        :color="props.item.Chamber == 'Senate'
                            ? $store.state.COLOUR_SENATE
                            : props.item.Chamber == 'House'
                            ? $store.state.COLOUR_REPRESENTATIVES
                            : $store.state.COLOUR_JOINT">
                        {{ props.item.Type }}
                    </v-chip>
                    </td>
                    <td class="text-xs-left">{{ props.item.Name }}</td>
                    <td class="text-xs-left">
                    {{ props.item.ServiceStartDate | stringDateFormat }}
                    </td>
                    <td class="text-xs-left">
                    {{ props.item.Current ? "Current" : "" }}
                    {{ props.item.ServiceEndDate | stringDateFormat }}
                    </td>
                </template>
                <template v-slot:no-results>
                <v-alert :value="true" color="error" icon="warning">
                    Your search for "{{ committeeSearch }}" found no results.
                </v-alert>
                </template>
            </v-data-table>
        </template>
    </v-container>
</template>
<script>
import Loader from '@/components/Loader.vue';
import StatisticalHeader from './StatisticalHeader.vue';
import Chart from './Chart.vue';
import CountUp from './CountUp.vue';
import axios from 'axios';
window.Handbook = window.Handbook || {}
const apiUri = window.Handbook.ApiUri || "https://localhandbookapi.aph.gov.au/";
axios.defaults.baseURL = apiUri;

export default {
    created() {
        this.initialiseStats();
    },
    components: {
        Loader,
        StatisticalHeader,
        Chart,
        CountUp
    },
    methods: {
         onToggle(){
            this.DATATABLE_COMMITTEES = this.committees.filter(h => this.toggleChambers.indexOf(h.Chamber.toLowerCase()) > -1
                    && this.toggleType.indexOf(h.Type.replace(h.Chamber + ' ', '')) > -1);
        },
        getColor(chamber){
            if (chamber == 'House'){
                return this.$store.state.COLOUR_REPRESENTATIVES;
            }
            else if (chamber == 'Senate'){
                return this.$store.state.COLOUR_SENATE_BRIGHT;
            }
            else if (chamber == 'Joint'){
                return this.$store.state.COLOUR_JOINT;
            }
        },
        initialiseStats() {
            this.loading = true;
            const mpOrSenator = this.selectedMpOrSenator.length == 0 || this.selectedMpOrSenator.length == 2 ?
                '' : this.selectedMpOrSenator[0];
            const url = `StatisticalInformation/CommitteeStatistics?mpOrSenator=${mpOrSenator}&fullData=true`;
            axios.get(`api/${url}`)
                .then(response => {
                    this.committeeCount = response.data.Committees.length;
                    this.committees = response.data.Committees.slice().reverse();
                    this.DATATABLE_COMMITTEES = this.committees;
                    this.loading = false;
                });
        },
        filterMpOrSenator() {
            this.initialiseStats();
        },
        exportCsv: function () {
            this.csvDownloading = true;
            const records = this.items
                .map(i => ({ Date: new Date(i.Date).toLocaleDateString(), ...i.Parties.reduce((ac,a) => ({...ac,[a.Party]: a.WomenCount }),{}) }));
            let headers = this.headers.map(h => h.text);
            const filename = this.title;
            const comment = `Data current as of ${(new Date()).toLocaleDateString()}`;
            this.$store.dispatch('GETCSV', { DATA: records, HEADERS: headers, FILENAME: filename, COMMENT: comment })
                .catch(this.showError)
                .finally(() => this.csvDownloading = false);
        }
    }, 
    computed: {
            csvDownloadIcon() {
                return this.csvDownloading ? 'cached' : 'text_snippet';
            },
            csvDownloadClass() {
                let csvClass = 'mr-1';
                if (this.csvDownloading){
                    csvClass = csvClass + ' loading'
                }
                return csvClass;
            },
            
            timelineChartData() {
               

                const data = this.committees.filter(h => this.toggleChambers.indexOf(h.Chamber.toLowerCase()) > -1 
                && this.toggleType.indexOf(h.Type.replace(h.Chamber + ' ', '')) > -1)
                .map((i, index) => {
                    let label = i.Name + ' (' + i.Type + ')';
                    // try to find colour based on dates
                    let colour = this.getColor(i.Chamber);

                    return {
                        x: new Date(i.ServiceStartDate).valueOf(),
                        x2: i.ServiceEndDate ? new Date(i.ServiceEndDate).valueOf() : new Date().valueOf(),
                        y: index,
                        color: colour,
                        label: '(' + i.Type + ') ' + i.Name,
                    }
                });
            

            const plotLines = this.$store.getters.GET_PARLIAMENTS_ORDERED
                .map(p => ({
                    value: (new Date(p.DateOpening)).valueOf(),
                    dashStyle: 'shortdash',
                    color: '#CCD6EB',
                    label: {
                        text: p.PID
                    }}));

            return {
                chart: {
                    type: 'xrange',
                    backgroundColor: '#f5f5f5',
                    height: data.length * 15
                },
                exporting: {
                    enabled: false
                },
                tooltip: {
                    formatter: function () {
                        var todaysDate = new Date();
                        var dateIsToday = new Date(this.x2).setHours(0,0,0,0) == todaysDate.setHours(0,0,0,0);
                        var showEndDate = dateIsToday ? 'current' : new Date(this.x2).toLocaleDateString('en-AU');
                        return `<div>${this.point.label} - ${new Date(this.x).toLocaleDateString('en-AU')} - ${showEndDate}</div>`;
                    },
                    backgroundColor: 'rgba(255, 255, 255, 0)',
                    shadow: false,
                    borderWidth: 0,
                    borderRadius: 0,
                    useHTML: true,
                },
                
                title: {
                    text: ''
                },
                accessibility: {
                    point: {
                        descriptionFormatter: function (point) {
                            var ix = point.index + 1,
                                category = point.yCategory,
                                from = new Date(point.x),
                                to = new Date(point.x2);
                            return ix + '. ' + category + ', ' + from.toDateString() +
                                ' to ' + to.toDateString() + '.';
                        }
                    }
                },
                plotOptions: {
                    series: {
                        colorByPoint: true,
                        minPointLength: 10,
                    }
                },
                xAxis: [
                    {
                        title: {
                            text: ''
                        },
                        min: new Date(1900, 1, 1).valueOf(),
                        max: new Date(),
                        type: 'datetime',
                        reversed: false,
                        tickLength: 0,
                        lineColor: '#dddddd'
                        // plotLines
                    },
                    {
                        title: {
                            text: ''
                        },
                        min: new Date(1901, 1, 1).valueOf(),
                        max: new Date(),
                        type: 'datetime',
                        reversed: false,
                        tickLength: 0,
                        lineColor: '#dddddd',
                        linkedTo: 0,
            opposite: true,
                        // plotLines
                    }
                ],
                yAxis: {
                    title: {
                        text: 'Committees over time'
                    },
                    categories: [...data.map(a => a.label)],
                },
                legend: {
                    enabled: false
                },
                series: [{
                    name: '',
                    pointWidth: 10,
                    colorByPoint: true,
                    data: [...data]
                }]
            }
        },
            committeeDumbells() {
                const data = this.committees.slice(0, 50).map(i => 
                ({
                    name: i.Name,
                    type: i.Type,
                    chamber: i.Chamber,
                    low: Date.parse(i.ServiceStartDate).valueOf(),
                    high: i.ServiceEndDate == null ? new Date().valueOf() : Date.parse(i.ServiceEndDate).valueOf(),
                    color: this.getColor(i.Chamber)
                }));

                return {
                    chart: {
                        type: 'dumbbell',
                        inverted: true,
                        height: 2000
                    },
                    tooltip: {
                        formatter: function () {
                            return `${this.point.name} - ${new Date(this.point.low).toLocaleDateString("en-AU")} - ${new Date(this.point.high).toLocaleDateString("en-AU")}`
                        },
                    },
                    legend: {
                        enabled: false
                    },
                    title: {
                        text: 'Committees in Parliament over time'
                    },
                    xAxis: {
                        type: 'category',
                        labels: {
                            step: 1
                        },
                        endOnTick: false,
                    },
                    yAxis: {
                        type: 'datetime',
                        min: Date.UTC(1900, 1, 1, 0),
                    },

                    series: [{
                        name: 'Committee lifespan',
                        data,
                        lineWidth:4
                    }]                    
                }
            }
    },
    watch: {
        selectedMpOrSenator: function () {
            this.initialiseStats();
        }
    },
    data() {
        return {
        title: 'Committee timeline',
        toggleChambers: ['senate', 'house', 'joint'],
        toggleType: ['Standing', 'Statutory', 'Select', 'Estimates', 'Legislative and General Purpose Standing'],
        headers: [],
        items: [],
        stats: [],
        committees: [],
         DATATABLE_COMMITTEES: [],
          ROWS_LISTITEMS: [
        10,
        20,
        50,
        100,
        {
          text: "$vuetify.dataIterator.rowsPerPageAll",
          value: -1,
        },
      ],
      
      PAGINATION: {
            rowsPerPage: 50,
            sortBy: "CommitteeName",
        },
        HEADERS: [
        {
          text: "Committee type",
          value: "CommitteeType",
          align: "left",
          sortable: true,
          width: "100px",
        },
        {
          text: "Committee name",
          value: "CommitteeName",
          align: "left",
          sortable: true,
          model: this.committeeName,
        },
        {
          text: "Member service start",
          value: "StartDate",
          align: "left",
          sortable: true,
          width: "100px",
        },
        {
          text: "Member service end",
          value: "EndDate",
          align: "left",
          sortable: true,
          width: "100px",
        }],
        currentParliament: 0,
        totalStats: [],
        percentage: 0,
        committeeCount: 0,
        currentCommitteeCount: 0,
        totalStatsOptions: {
            suffix: '%'
        },
        parties: [],
        partiesExcludingTotal: [],
        search: '',
        loading: true,
        csvDownloading: false,
        selectedMpOrSenator: ['senator', 'mp'],
        rowsPerPageItems: [ {
            "text": "$vuetify.dataIterator.rowsPerPageAll",
            "value": -1
            }]
        }
    }
}
</script>
<style scoped>
    .chamberButton {
        color: #f5f5f5;
    }
</style>